import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { InputListTag, InputItem } from "./styles";

class InputList extends Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
  };

  static Item = InputItem;

  render() {
    const { children } = this.props;
    return (
      <InputListTag>
        {children}
      </InputListTag>
    );
  }
}

export default InputList;
